var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66927 2.66683H13.3359V10.6668H3.44927L2.66927 11.4468V2.66683ZM2.66927 1.3335C1.93594 1.3335 1.3426 1.9335 1.3426 2.66683L1.33594 14.6668L4.0026 12.0002H13.3359C14.0693 12.0002 14.6693 11.4002 14.6693 10.6668V2.66683C14.6693 1.9335 14.0693 1.3335 13.3359 1.3335H2.66927ZM4.0026 8.00016H9.33594V9.3335H4.0026V8.00016ZM4.0026 6.00016H12.0026V7.3335H4.0026V6.00016ZM4.0026 4.00016H12.0026V5.3335H4.0026V4.00016Z",
    fill: "#4D5D89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionIcon);
export default __webpack_public_path__ + "static/media/mention_icon.5ee0eaeecfa1ff695178f31299b93af8.svg";
export { ForwardRef as ReactComponent };